<template>
  <div class="flex-row">
    <div class="row-item no-text-select" v-if="showDateRangeFilter" v-click-outside="() => closeFilter('date_range')">
      <div @click="toggleDateRangeFilter">
        <img src="../../../assets/images/filterdaterange.svg" class="row-item-icon"/>
        <span class="row-item-txt">
          {{$t('calendar')}}{{dateRangeFilterData.startDate || dateRangeFilterData.endDate ? ':' : ''}} <span class="show-filters"> {{dateRangeFilterData.startDate ? dateRangeFilterData.startDate : ''}}{{dateRangeFilterData.startDate && dateRangeFilterData.endDate ? ' / ' : ''}}{{dateRangeFilterData.endDate ? dateRangeFilterData.endDate : ''}}</span>
          </span>
      </div>
      <DateFilter
          v-if="showDateRangeDropdown"
          :visible.sync="showDateRangeDropdown"
          :on-filter="handleApplyDateFilters"
      />
      <img src="../../../assets/images/cross.svg" @click="() => removeFilter('date_range')" />
    </div>
    <div class="row-item no-text-select" v-if="showStatusFilter" v-click-outside="() => closeFilter('status')">
      <div @click="toggleStatusFilter">
        <img src="../../../assets/images/filterprogramnumber.svg" class="row-item-icon" />
        <span class="row-item-txt">
          {{$t('status')}}{{statusFilterData.status===undefined? '' : ':'}} <span class="show-filters">{{getStatusLabel(statusFilterData.status)}}</span>
          </span>
      </div>
      <StatusFilterForFiles
          v-if="showStatusFilterDropdown"
          :visible.sync="showStatusFilterDropdown"
          :on-filter="handleStatusFilter"
          :filter-items="statusFilterItems"
      />

      <img src="../../../assets/images/cross.svg" @click="() => removeFilter('status')" />
    </div>

    <div class="row-item filter" v-click-outside="() => closeFilter('main')" @click="toggleFilter">
      <img src="../../../assets/images/filter.svg">
      <span class="row-item-txt no-text-select">
            {{ $t('filter_program') }}
        </span>
      <FilterModal :visible.sync="showFilter" @filter-selected="handleFilterSelected"/>
    </div>
  </div>
</template>

<script>
import DateFilter from "@/components/table-filters/DateFilter.vue";
import FilterModal from "@/components/tables/File/FileFilterModal.vue";
import MinMaxNumberFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import StatusFilterForFiles from "@/components/table-filters/StatusFilterForFiles.vue";

export default {
  components: {
    StatusFilterForFiles,
    MinMaxNumberFilter,
    DateFilter,
    FilterModal
  },
  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {

        if (this.$route.query.addedDate) {
          this.showDateRangeFilter = true;
          this.dateRangeFilterData.startDate = this.$route.query.addedDate;
        } else {
          this.dateRangeFilterData.startDate = undefined
        }

        if (this.$route.query.addedDateEnd) {
          this.showDateRangeFilter = true;
          this.dateRangeFilterData.endDate = this.$route.query.addedDateEnd;
        } else {
          this.dateRangeFilterData.endDate = undefined
        }

        if (this.$route.query.status !== undefined) {
          this.showStatusFilter = true;
          this.statusFilterData.status = this.$route.query.status;
        } else {
          this.statusFilterData.status = undefined
        }

      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      showFilter:false,

      showStatusFilter:false,
      showStatusFilterDropdown:false,
      statusFilterData:{
        status:undefined,
      },

      showDateRangeFilter: false,
      showDateRangeDropdown: false,
      dateRangeFilterData: {
        startDate: undefined,
        endDate: undefined,
      },

      statusFilterItems:[
        {
          id: 0, // Backend PENDING = 0
          name: this.$t('pending'),
        },
        {
          id: 1, // Backend APPROVED = 1
          name: this.$t('approved'),
        },
        {
          id: 2, // Backend REJECTED = 2
          name: this.$t('rejected'),
        },
      ],
    }
  },
  methods: {
    getStatusLabel(status) {
      if (status === undefined || status === null) return '';

      const statusStr = String(status);

      switch(statusStr) {
        case "0":
          return this.$t('pending');
        case "1":
          return this.$t('approved');
        case "2":
          return this.$t('rejected');
        default:
          return '';
      }
    },

    handleFilterSelected(filterName) {
      this.closeFilter('main');
      if (filterName === 'date_range') {
        this.showDateRangeFilter = true;
        this.showDateRangeDropdown = true;
      } else if (filterName === 'status') {
        this.showStatusFilter=true;
        this.showStatusFilterDropdown=true;
      }
    },

    formatDateForBackend(dateString) {
      if (!dateString) return undefined;
      // DateString already comes in DD-MM-YYYY format, just return it
      return dateString;
    },

    handleApplyDateFilters(filters){
      this.dateRangeFilterData.startDate = filters.startDate;
      this.dateRangeFilterData.endDate = filters.endDate;
      this.showDateRangeDropdown = false;
      console.log('Start Date:', this.$route.query.addedDate);
      console.log('End Date:', this.$route.query.addedDateEnd);
      this.$router.push({
        query: {
          ...this.$route.query,
          addedDate: filters.startDate, // Already in DD-MM-YYYY format
          addedDateEnd: filters.endDate // Already in DD-MM-YYYY format
        }
      });
    },

    handleStatusFilter(filter){
      this.statusFilterData = filter;
      this.showStatusFilterDropdown = false;

      this.$router.push({
        query: {
          ...this.$route.query,
          status: String(this.statusFilterData.status) // Convert to string for consistency
        }
      });
    },

    toggleFilter() {
      this.showFilter = !this.showFilter;
    },

    toggleDateRangeFilter() {
      this.showDateRangeDropdown = !this.showDateRangeDropdown;
    },

    toggleStatusFilter() {
      this.showStatusFilterDropdown = !this.showStatusFilterDropdown;
    },

    closeFilter(filter) {
      if (filter === 'main' && this.showFilter === true) {
        this.showFilter = false;
      } if (filter === 'date_range' && this.showDateRangeDropdown === true) {
        this.showDateRangeDropdown = false;
      } else if (filter === 'status' && this.showStatusFilterDropdown === true) {
        this.showStatusFilterDropdown = false;
      }
    },

    removeFilter(filter) {
      if (filter === 'date_range') {
        this.showDateRangeFilter = false;
        this.dateRangeFilterData = {
          startDate: undefined,
          endDate: undefined,
        };
        this.$router.push({
          query: {
            ...this.$route.query,
            addedDate: undefined,
            addedDateEnd: undefined
          }
        })
      } else if (filter === 'status') {
        this.showStatusFilter = false;
        this.statusFilterData = {
          status: undefined
        };
        this.$router.push({
          query: {
            ...this.$route.query,
            status: undefined
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.flex-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}
.row-item{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
  background-color: #f2f2f2;
  position: relative;
  cursor: pointer;
}

.row-item.filter {
  background-color: transparent;
}

.row-item-txt{
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  font-weight: 500;
  font-style: normal;
  white-space: nowrap;
}

.show-filters{
  font-family: euclid_medium, sans-serif;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}
</style>
